import styled from '@emotion/styled'

export const Container = styled.div`
  font-family: monospace, sans-serif;
  display: grid;
  place-items: center;
`

export const Cupom = styled.div`
  font-size: 12px;
  width: 300px;
  padding: 5px;
`

export const Separator = styled.div`
  max-width: 100%;
  height: 10px;
  border-bottom: dashed 1px #000000;
  margin-bottom: 10px;
`

export const Total = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Footer = styled.div`
  text-align: center;
`
